import { render, staticRenderFns } from "./pdfPreview.vue?vue&type=template&id=1a98fbe2&scoped=true&"
import script from "./pdfPreview.vue?vue&type=script&lang=ts&"
export * from "./pdfPreview.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a98fbe2",
  null
  
)

export default component.exports